var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 0.803044C12.2374 0.510151 11.7626 0.510151 11.4697 0.803044L4.803 7.46971C4.66235 7.61036 4.58333 7.80113 4.58333 8.00004V10.6667C4.58333 11.0809 4.91912 11.4167 5.33333 11.4167H8C8.19891 11.4167 8.38968 11.3377 8.53033 11.197L15.197 4.53037C15.4899 4.23748 15.4899 3.7626 15.197 3.46971L12.5303 0.803044ZM6.08333 9.91671V8.3107L12 2.39403L13.606 4.00004L7.68934 9.91671H6.08333ZM2.75 3.33337C2.75 3.01121 3.01117 2.75004 3.33333 2.75004H6.89333C7.30755 2.75004 7.64333 2.41425 7.64333 2.00004C7.64333 1.58583 7.30755 1.25004 6.89333 1.25004H3.33333C2.18274 1.25004 1.25 2.18278 1.25 3.33337V12.6667C1.25 13.8173 2.18274 14.75 3.33333 14.75H12.6667C13.8173 14.75 14.75 13.8173 14.75 12.6667V9.10671C14.75 8.69249 14.4142 8.35671 14 8.35671C13.5858 8.35671 13.25 8.69249 13.25 9.10671V12.6667C13.25 12.9889 12.9888 13.25 12.6667 13.25H3.33333C3.01117 13.25 2.75 12.9889 2.75 12.6667V3.33337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5399e6f8ae82b626f2f404f0284cb2a1.svg";
export { ForwardRef as ReactComponent };